function pricing() {
  const signupProfessional = document.getElementById("signup-professional");
  const signupChampion = document.getElementById("signup-champion");
  const signupBusiness = document.getElementById("signup-business");
  if (signupProfessional) {
    signupProfessional.addEventListener("click", (eve) => {
      eve.preventDefault();
      location.href = "/signup?package=TRIAL_PRO";
    });
  }
  if (signupChampion) {
    signupChampion.addEventListener("click", (eve) => {
      eve.preventDefault();
      location.href = "/signup?package=TRIAL_SC_PLAN_STANDARD_V5";
    });
  }
  if (signupBusiness) {
    signupBusiness.addEventListener("click", (eve) => {
      eve.preventDefault();
      location.href = "/signup?package=TRIAL_BUSINESS_CHAMP";
    });
  }

  $('[data-toggle="tooltip"]').tooltip({
    trigger: "click hover manual",
  });
  $('[data-toggle="tooltip"]').on("shown.bs.tooltip", (e) => {
    $('[data-toggle="tooltip"]')
      .not(`#${$(e.currentTarget).attr("id")}`)
      .tooltip("hide");
  });
}

export default pricing;
